<template>
  <v-card class="rounded-lg">
    <v-toolbar color="primary" density="compact">
      <v-icon class="ml-4" size="small">mdi-account-details</v-icon>
      <v-toolbar-title class="text-subtitle-2 font-weight-bold ml-2">DATOS DEL ALUMNO</v-toolbar-title>
      <v-spacer />
      <v-btn
        :icon="editable ? 'mdi-check' : 'mdi-pencil'"
        variant="text"
        density="compact"
        size="small"
        class="mr-3"
        @click="toggleEdit"
      />
    </v-toolbar>

    <v-card-text class="pt-4">
      <div class="foto-wrapper mb-4">
        <div class="foto-frame" @click="abrirFotoGrande">
          <v-img :src="fotoActual" contain class="foto-img" />
          <div class="foto-overlay">
            <v-icon color="white" size="32">mdi-magnify-plus-outline</v-icon>
          </div>
        </div>
      </div>

      <v-dialog v-model="fotoDialog" max-width="600">
        <v-card class="rounded-lg">
          <v-img :src="fotoActual" max-height="80vh" contain />
          <v-card-actions>
            <v-spacer />
            <v-btn variant="text" @click="fotoDialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div v-if="editable" class="mb-4">
        <input
          ref="fotoInput"
          type="file"
          accept="image/*"
          class="d-none"
          @change="handleFotoSeleccionada"
        >
        <v-btn
          block
          color="primary"
          variant="tonal"
          prepend-icon="mdi-camera"
          size="small"
          @click="abrirSelectorFoto"
        >
          Adjuntar foto
        </v-btn>
        <v-btn
          v-if="tieneFoto"
          block
          class="mt-2"
          color="error"
          variant="tonal"
          prepend-icon="mdi-delete"
          size="small"
          :loading="eliminandoFoto"
          @click="$emit('delete-photo')"
        >
          Borrar foto
        </v-btn>
      </div>

      <v-text-field
        density="compact"
        variant="outlined"
        label="NOMBRES"
        v-model="localAlumno.nombres"
        :readonly="!editable"
        @input="updateLocalAlumno"
      />

      <v-text-field
        density="compact"
        variant="outlined"
        label="APELLIDO PATERNO"
        v-model="localAlumno.apellido_paterno"
        :readonly="!editable"
        @input="updateLocalAlumno"
      />

      <v-text-field
        density="compact"
        variant="outlined"
        label="APELLIDO MATERNO"
        v-model="localAlumno.apellido_materno"
        :readonly="!editable"
        @input="updateLocalAlumno"
      />

      <v-text-field
        density="compact"
        variant="outlined"
        label="TIPO DOCUMENTO"
        :model-value="tipoDocumentoTexto"
        readonly
      />

      <v-text-field
        density="compact"
        variant="outlined"
        label="DOCUMENTO"
        v-model="localAlumno.numero_documento"
        :readonly="!editable"
        @input="updateLocalAlumno"
      />

      <v-row dense>
        <v-col cols="7">
          <v-text-field
            density="compact"
            variant="outlined"
            label="NACIMIENTO"
            v-model="localAlumno.fecha_nacimiento"
            :readonly="!editable"
            type="date"
            @input="updateLocalAlumno"
          />
        </v-col>
        <v-col cols="5">
          <v-text-field
            density="compact"
            variant="outlined"
            label="EDAD"
            :model-value="edad"
            readonly
          />
        </v-col>
      </v-row>

      <v-text-field
        density="compact"
        variant="outlined"
        label="EMAIL"
        v-model="localAlumno.email"
        :readonly="!editable"
        @input="updateLocalAlumno"
      />
      <v-text-field
        density="compact"
        variant="outlined"
        label="CELULAR"
        v-model="localAlumno.celular"
        :readonly="!editable"
        prepend-inner-icon="mdi-phone"
        @input="updateLocalAlumno"
      />
      <v-text-field
        density="compact"
        variant="outlined"
        label="DIRECCION"
        v-model="localAlumno.direccion"
        :readonly="!editable"
        @input="updateLocalAlumno"
      />

      <v-select
        density="compact"
        variant="outlined"
        label="GENERO"
        v-model="localAlumno.genero_id"
        :items="generos"
        item-title="descripcion"
        item-value="id"
        :readonly="!editable"
        @update:model-value="updateLocalAlumno"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    alumno: {
      type: Object,
      required: true
    },
    editableAlumno: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    fotoAlumno: {
      type: String,
      required: true
    },
    edad: {
      type: String,
      required: true
    },
    generos: {
      type: Array,
      default: () => []
    },
    tieneFoto: {
      type: Boolean,
      default: false
    },
    eliminandoFoto: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-edit', 'update', 'delete-photo'],
  data() {
    return {
      localAlumno: { ...this.editableAlumno },
      fotoDialog: false,
    };
  },
  watch: {
    editableAlumno: {
      handler(nuevo) {
        this.localAlumno = { ...nuevo };
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    fotoActual() {
      return this.localAlumno.fotoPreview || this.fotoAlumno;
    },
    tipoDocumentoTexto() {
      const tipos = {
        1: 'DNI',
        2: 'PASAPORTE',
        3: 'CARNET DE EXTRANJERIA',
      };

      return tipos[this.localAlumno.tipo_documento_id] || 'No definido';
    },
  },
  methods: {
    abrirSelectorFoto() {
      this.$refs.fotoInput?.click();
    },

    toggleEdit() {
      this.$emit('toggle-edit');
    },

    handleFotoSeleccionada(event) {
      const [file] = event.target.files || [];
      if (!file) return;

      this.localAlumno = {
        ...this.localAlumno,
        foto: file,
        fotoPreview: URL.createObjectURL(file),
      };
      this.updateLocalAlumno();
    },

    updateLocalAlumno() {
      this.$emit('update', this.localAlumno);
    },

    abrirFotoGrande() {
      if (!this.fotoActual) return;
      this.fotoDialog = true;
    }
  }
};
</script>

<style scoped>
.foto-wrapper {
  display: flex;
  justify-content: center;
}

.foto-frame {
  position: relative;
  width: 70%;
  max-width: 180px;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.15), rgba(var(--v-theme-primary), 0.05));
  padding: 4px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.foto-frame:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.25);
}

.foto-img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  border: 3px solid rgb(var(--v-theme-surface));
}

.foto-overlay {
  position: absolute;
  inset: 4px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.foto-frame:hover .foto-overlay {
  opacity: 1;
}
</style>
